import { useState } from "react";

export default function Products() {
  const [selectedImage, setSelectedImage] = useState(null);

  const products = [
    {
      src: "/images/soap/nalanguma.jpg",
      title: "Nalanguma Soap",
      price: "80g - 750/- \n25g - 320/-",
      desc: `For bright & soft skin complexion, prevents acne and wrinkles. Not suitable for 
              people with allergy to Turmeric.<br/>
              பிரகாசமான மற்றும் மென்மையான சருமத்திற்கு. முகப்பரு மற்றும் தோல்
              சுருக்கங்களை தடுக்கிறது. மஞ்சள் ஒவ்வாமை உள்ளவர்களிற்கு பொருத்தமற்றது.`,
    },
    {
      src: "/images/soap/neem.jpg",
      title: "Neem & Tea Tree oil Soap",
      price: "80g - 750/- \n25g - 320/-",
      desc: `Prevents pimples and acne. Good for skin rashes.<br/>
              பருக்கள் மற்றும் முகப்பருவைத் தடுக்கிறது. தோல் வெடிப்புகளுக்கு நல்லது.`,
    },
    {
      src: "/images/soap/MultaniMitti.jpg",
      title: "Multani Mitti & Rose Soap",
      price: "80g - 750/- \n25g - 320/-",
      desc: `For smooth and radiant skin, oil balancing, acne control. Reduces sun tan and pigmentation.<br/>
              மென்மையான மற்றும் பளபளப்பான சருமத்திற்கு, எண்ணெய் சமநிலை, முகப்பரு கட்டுப்பாடு. 
              சூரிய ஒளியின் தாக்கம் மற்றும் நிறமியைக் குறைக்கிறது.`,
    },
    {
      src: "/images/soap/Manjisti.jpg",
      title: "Goat milk-Manjisti-Red sandalwood Soap",
      price: "80g - 750/- \n25g - 320/-",
      desc: `For bright and soft skin. Moisturises the skin and gives natural glow.<br/>
              பிரகாசமான மற்றும் மென்மையான சருமத்திற்கு. சருமத்தை ஈரப்பதமாக்கி இயற்கையான பளபளப்பை அளிக்கிறது.`,
    },
  ];

  return (
    <div className="p-6 text-center bg-green-50 min-h-screen">
      <div className="mt-12">
        <h3 className="text-2xl font-semibold text-green-800 mb-6">Our Products</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">

          {products.map((product, i) => (
            <div key={i} className="relative group bg-white p-4 rounded-xl shadow-md overflow-hidden">
              {/* Clickable image */}
              <img
                src={product.src}
                alt={product.title}
                className="rounded-md mb-3 w-full h-56 object-cover cursor-pointer"
                onClick={() => setSelectedImage(product.src)}
              />

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-green-900/70 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-500 rounded-md pointer-events-none">
                {/* <p className="text-white text-sm px-4">{product.desc}</p> */}
                <p
                  className="text-white text-sm px-4"
                  dangerouslySetInnerHTML={{ __html: product.desc }}
                />
              </div>

              <h4 className="text-xl font-medium text-green-700 mt-3">{product.title}</h4>
              <p className="text-sm text-gray-600 whitespace-pre-line">{product.price}</p>
            </div>
          ))}

        </div>
      </div>

      {/* Popup Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative">
            <img
              src={selectedImage}
              alt="Enlarged"
              className="max-h-[90vh] max-w-[90vw] rounded-lg shadow-lg"
            />
            {/* Close Button */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-2 right-2 bg-white rounded-full p-2 shadow-md"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
}